interface TelegramInitData {
  initData: string | null;
  initDataUnsafe: unknown | null;
}

export function getTelegramInitData(): TelegramInitData {
  const tg = (window as any).Telegram?.WebApp;

  if (!tg?.initData || !tg?.initDataUnsafe) {
    return {
      initData: null,
      initDataUnsafe: null,
    };
  }

  return {
    initData: tg.initData,
    initDataUnsafe: tg.initDataUnsafe,
  };
}